import { Controller } from '@hotwired/stimulus';

export default class ProfileCompletionController extends Controller {
  static targets = ['maritalRegime', 'maritalStatus', 'professionalSituation', 'profession', 'activitySector'];
  static values = { professionMapping: Object };

  connect() {
    this.allProfessionOptions = Array.from(this.professionTarget.options).map(function (opt) {
      return { value: opt.value, text: opt.text };
    });

    this.toggleMaritalRegime();
    this.filterProfessions();
    this.toggleActivitySector();

    this.maritalStatusTarget.addEventListener('change', this.toggleMaritalRegime.bind(this));
    this.professionalSituationTarget.addEventListener('change', this.onProfessionalSituationChange.bind(this));
    this.professionTarget.addEventListener('change', this.onProfessionChange.bind(this));
  }

  toggleMaritalRegime() {
    const isMarried = this.maritalStatusTarget.value === 'married';
    this.maritalRegimeTarget.disabled = !isMarried;
    if (!isMarried) {
      this.maritalRegimeTarget.value = '';
    }
    this.refreshSelect2(this.maritalRegimeTarget);
  }

  onProfessionalSituationChange() {
    this.filterProfessions();
    this.toggleActivitySector();
  }

  onProfessionChange() {
    const professionValue = this.professionTarget.value;
    if (professionValue && this.professionMappingValue[professionValue]) {
      this.professionalSituationTarget.value = this.professionMappingValue[professionValue];
      this.refreshSelect2(this.professionalSituationTarget);
    }
    this.toggleActivitySector();
  }

  filterProfessions() {
    const selectedSituation = this.professionalSituationTarget.value;
    const mapping = this.professionMappingValue;
    const currentValue = this.professionTarget.value;
    const select = this.professionTarget;

    // Clear all options except the blank one
    while (select.options.length > 1) {
      select.remove(1);
    }

    // Re-add matching options
    const self = this;
    this.allProfessionOptions.forEach(function (opt) {
      if (opt.value === '') return; // skip blank option

      if (!selectedSituation || mapping[opt.value] === selectedSituation) {
        const option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        if (opt.value === currentValue) {
          option.selected = true;
        }
        select.appendChild(option);
      }
    });

    // If current value no longer available, reset
    if (currentValue && !mapping[currentValue]) {
      select.value = '';
    }
    if (selectedSituation && currentValue && mapping[currentValue] !== selectedSituation) {
      select.value = '';
    }

    this.refreshSelect2(select);
  }

  toggleActivitySector() {
    const situation = this.professionalSituationTarget.value;
    const shouldDisable = !this.professionTarget.value || situation === 'student' || situation === 'inactive';
    this.activitySectorTarget.disabled = shouldDisable;
    if (shouldDisable) {
      this.activitySectorTarget.value = '';
    }
    this.refreshSelect2(this.activitySectorTarget);
  }

  refreshSelect2(element) {
    const $el = $(element);
    if (!$el.data('select2')) return;

    $el.select2('destroy');
    const opts = { minimumResultsForSearch: Infinity, width: '100%' };
    if (element.querySelector('option[value=""]')) {
      opts.placeholder = ' ';
    }
    $el.select2(opts);
  }
}
